import React, { FC, useMemo } from 'react';
import { ExarePriceDetailsPriceElementType, RefundPricesFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { getTotalPriceFilteredElements, getZeroPrice } from '@shared/lib/money';
import ShortDetails from '../ShortDetails/ShortDetails';
import { DetailItem } from '../ShortDetails/types';
import { isFareElement, isTaxesAgency, isTaxesRetention } from './utils';

interface Props {
	prices: RefundPricesFragment;
	className?: string;
}

const ExtendedDetails: FC<Props> = ({ prices, className }) => {
	const { t } = useTranslation('Refund');

	const details = useMemo(() => {
		const items: DetailItem[] = [];

		const priceDetails = prices.priceDetails;
		const currentCurrency = prices.basePrice?.currency;

		const airticketFare =
			priceDetails?.refunded.elements?.find(isFareElement) ||
			priceDetails?.retention.elements?.find(isFareElement);

		const agencyTaxes = priceDetails?.retention.elements?.filter(isTaxesAgency);
		const retentionTaxes = priceDetails?.retention.elements?.filter(isTaxesRetention);

		items.push({
			name: `${t('Ticket price')}:`,
			price: prices.basePrice || getZeroPrice(currentCurrency)
		});

		items.push({
			name: `${t('Airticket fare')}:`,
			price: airticketFare?.money || getZeroPrice(currentCurrency)
		});

		agencyTaxes?.forEach(tax => {
			items.push({
				name: t(`${tax.taxCode}_taxesAgency`, {
					defaultValue: t('{{taxCode}} air ticket processing fee (non-refundable)', { taxCode: tax.taxCode })
				}),
				price: tax.money || getZeroPrice(currentCurrency),
				isMinus: true
			});
		});

		retentionTaxes?.forEach(tax => {
			items.push({
				name: t(`${tax.taxCode}_taxesRetention`, {
					defaultValue: t('{{taxCode}} return processing fee', { taxCode: tax.taxCode })
				}),
				price: tax.money || getZeroPrice(currentCurrency),
				isMinus: true
			});
		});

		items.push({
			name: t('Cost of refundable services'),
			price: getTotalPriceFilteredElements(
				priceDetails?.refunded.elements,
				ExarePriceDetailsPriceElementType.gdsServiceFare,
				currentCurrency
			)
		});

		items.push({
			name: t('Cost of non-refundable services'),
			price: getTotalPriceFilteredElements(
				priceDetails?.retention.elements,
				ExarePriceDetailsPriceElementType.gdsServiceFare,
				currentCurrency
			),
			isMinus: true
		});

		return items;
	}, [t, prices]);

	console.log(details);

	return <ShortDetails className={className} prices={prices} items={details} />;
};

export default ExtendedDetails;
